__turbopack_context__.v({
  "back": "I0rlha_back",
  "container": "I0rlha_container",
  "front": "I0rlha_front",
  "isChooser": "I0rlha_isChooser",
  "pair": "I0rlha_pair",
  "stacked": "I0rlha_stacked",
  "stats": "I0rlha_stats",
});
